module.exports = function(query, modifier) {
    var resizeFunction = ICF.Utils.EqualHeights.SetEqualHeights(query, modifier);

    resizeFunction();

    $(window).resize(resizeFunction);

    $(window).on('load', resizeFunction);

    return resizeFunction;
};